import { getObjectInfo } from '../../selectors/objectInfo';
import { dailyrentFetchReviews } from '../../services/reviews';
import { IReviews, TThunkAction } from '../../types/redux';
import { setAnswers } from '../answers';
import { setRatingFilters, setTagFilters } from '../filters';
import { setReviews } from './actions';
import { prepareTagsFiltersStore } from '../../mappers/prepareTagsFilters';

//TODO: В след задачах добавить cancellationToken и spinner
export function loadReviews(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi, config } = context;
    const shouldUsePageDataRequest = config.get<boolean>('Dailyrent.ReviewsPage.ShouldUsePageDataRequest') ?? false;
    const {
      custom: { deviceType },
    } = context;
    const state = getState();

    const { objectId } = getObjectInfo(state);

    // @todo добавить отдельный экшен для посуточных отзывов.
    // в этом экшене вернуть подгрузку новостроечных объектов
    try {
      const { availableFilters, tags, answers, reviews, hasMore, page } = await dailyrentFetchReviews({
        httpApi,
        parameters: { offerId: objectId },
        deviceType,
        shouldUsePageDataRequest,
      });

      dispatch(setRatingFilters(availableFilters));
      dispatch(setTagFilters(prepareTagsFiltersStore(tags)));
      dispatch(setAnswers(answers));
      dispatch(setReviews({ ...reviews, hasMore, page: page || 0 } as IReviews));
    } catch (error) {
      logger.error(error, {
        domain: 'reviews#loadReviews',
        message: error.message,
      });
    }
  };
}
